export const cilDrinkAlcohol = ["24 24","<path d='M11.625 20.625h-3.375v1.5h8.25v-1.5h-3.375v-5.673l8.25-9.036v-2.166h-18v2.166l8.25 9.036zM4.875 5.334v-0.084h15v0.084l-2.32 2.541h-10.36zM8.565 9.375h7.621l-3.766 4.125h-0.088z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-drink-alcohol.js
// module id = null
// module chunks = 